import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../app/hooks";
import { NotificationDialogBase } from "../../../common/components/functional/notificationDialog/NotificationDialogBase";
import {
  ExclusivityFormatLabels,
  formatExclusivityEntry,
} from "../../talentProfile/exclusivity/exclusivityHelpers";
import { TalentExclusivity } from "../../talents/talentAPI";
import { TalentLink } from "../editOrder/long/talentsStatus/TalentLink";
import { SelectedTalent } from "../types/editOrder";

type Props = {
  open: boolean;
  onClose: () => void;
  talent: SelectedTalent | null;
  exclusivities: TalentExclusivity[];
};

const WorkAgreementBlockingDialog = ({
  open,
  onClose,
  talent,
  exclusivities,
}: Props) => {
  const { t } = useTranslation(["order", "talentProfile", "common"]);
  const workTitleTranslations = useAppSelector(
    (state) => state.localized.workTitle,
  );

  if (!talent) return null;

  const labels: ExclusivityFormatLabels = {
    allWorkTitles: t("talentProfile:allWorkTitles"),
    allOrganizations: t("talentProfile:allOrganizations"),
    allWorkLocations: t("talentProfile:allWorkLocations"),
  };

  return (
    <NotificationDialogBase
      open={open}
      onClose={onClose}
      title={t("order:workOfferBlockedByExclusivityTitle")}
      closeLabel={t("common:close")}
      content={
        <>
          <Box mb={2}>
            <TalentLink id={talent.id} name={talent.fullName} status={talent.status} openInNewTab />
          </Box>
          <Typography mb={1}>
            {t("order:workOfferBlockedByExclusivityInfo")}
          </Typography>
          <Box>
            {exclusivities.map((ex) => (
              <Typography key={ex.id} fontWeight={600} fontSize="14px" mb={0.5}>
                {formatExclusivityEntry(ex, workTitleTranslations, labels)}
              </Typography>
            ))}
          </Box>
        </>
      }
    />
  );
};

export default WorkAgreementBlockingDialog;
